import { webApi } from '../../shared/api/WebApi';
import type {
  IAuthenticatedCPUser,
  IForgotPasswordReq,
  IResetPasswordReq,
} from '../../lib/types/Auth';
import type { CustomerInfoData } from '../../lib/types/Customer';

export class AuthApi {
  static login(username: string, password: string): Promise<IAuthenticatedCPUser> {
    return webApi.doLogin<IAuthenticatedCPUser>('login', username, password);
  }

  static forgotPassword(req: IForgotPasswordReq): Promise<void> {
    return webApi.post<void>('forgot-password-req', {}, req, { skipAuth: true });
  }

  static resetPassword(req: IResetPasswordReq): Promise<void> {
    return webApi.post<void>('reset-password-req', {}, req, { skipAuth: true });
  }
}

export class CustomerApi {
  static getCustomerInfo(cId: number): Promise<CustomerInfoData> {
    return webApi.get<CustomerInfoData>('customer/customerinfo', { cId });
  }
}
